import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=3da97748&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3da97748')) {
      api.createRecord('3da97748', component.options)
    } else {
      api.reload('3da97748', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=3da97748&", function () {
      api.rerender('3da97748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GvZ9dS5za3fH/JS/cancellationPolicy.vue"
export default component.exports